import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { UpdateGroceryStatusMutationVariables } from '@/gql/graphql';

export const updateGroceryStatus = async ({ orderId, status, reason, notes }: UpdateGroceryStatusMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation UpdateGroceryStatus($orderId: String!, $status: String!, $reason: String, $notes: String) {
        updateGroceryStatus(orderId: $orderId, status: $status, reason: $reason, notes: $notes) {
          id
          status
        }
      }
    `),
    variables: {
      orderId,
      status,
      reason,
      notes,
    },
  });

  return !!response.data?.updateGroceryStatus;
};
